<template>
  <div class="page-principal-faq">
        <div class="container">
            <h1>{{__('Dúvidas que talvez você tenha')}}</h1>

            <div class="row">
                <div class="col-sm-12 col-md-8">

                    <div class="faq-list">
                        <div 
                            v-for="faq,idx in faq_list" 
                            v-bind:key="`item_${idx}`"
                            @click="toogle_faq(idx)" 
                            class="faq-item"
                            :class="opened_faq == idx ? 'open':''"
                        >
                            <div v-html="__(faq.title)" class="faq-item-header"></div>
                            <div v-html="__(faq.description)" class="faq-item-description"></div>
                        </div>
                    </div>

                </div>
                <div class="col-sm-12 col-md-4">
                    <ContactForm/>
                </div>
            </div>
        </div>
  </div>
</template>
<script>
import Vue from "vue";
import "@/assets/scss/custom/principal/_faq.scss"
import ContactForm from '../components/apolar/principal/contact-form.vue';

export default {
  name: "faq",
  components: {
    ContactForm
  },
  head() {
    return {
      script: [
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "Tenho um imóvel para vender ou alugar. O que devo fazer?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Basta clicar em Anuncie ou entrar em contato com uma das nossas lojas. Os corretores Apolar estão preparados para fazer a melhor avaliação do mercado, garantindo agilidade no negócio."
            }
          },
          {
            "@type": "Question",
            "name": "Por que devo escolher a Apolar para administrar o meu imóvel?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "A Apolar tem mais de 50 anos de tradição no mercado imobiliário e se destaca pela força de divulgação, com mais de 100 lojas interligadas, equipe de especialistas e parceria com os principais portais. Conta também com equipe jurídica própria para assessoria completa."
            }
          },
          {
            "@type": "Question",
            "name": "Como funciona o processo de aluguel com a Apolar?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Apresentamos opções de imóveis de acordo com o perfil do cliente, realizamos a análise cadastral de forma rápida e oferecemos diferentes modalidades de garantia locatícia, como fiador, seguro-fiança e título de capitalização."
            }
          },
          {
            "@type": "Question",
            "name": "Que tipo de documentação preciso para alugar, comprar ou vender um imóvel?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Para alugar: RG e CPF. Para vender: documento do imóvel, RG, CPF e comprovante de estado civil. Para comprar: RG, CPF, comprovante de estado civil e certidões pessoais, se houver financiamento. Outros documentos podem ser solicitados conforme o caso."
            }
          },
          {
            "@type": "Question",
            "name": "Sou inquilino(a) da Apolar e estou com um problema no imóvel. A quem devo procurar?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "A Apolar oferece assistência técnica 24h, de forma gratuita. Basta ligar para 0800 707 79 56 e agendar uma visita."
            }
          },
          {
            "@type": "Question",
            "name": "Como a Apolar garante segurança na compra de um imóvel?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Realizamos análise completa da documentação do imóvel e do vendedor, e nossos consultores acompanham o processo até a assinatura do contrato, garantindo segurança ao comprador."
            }
          },
          {
            "@type": "Question",
            "name": "A Apolar oferece suporte para investidores imobiliários?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Sim! A Apolar possui equipe especializada que oferece análise de mercado, projeções de retorno e assessoria na escolha de ativos para locação, revenda ou incorporação."
            }
          },
          {
            "@type": "Question",
            "name": "Como funciona a indicação de imóveis para locação ou venda?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Qualquer pessoa pode indicar um imóvel à Apolar. Caso o imóvel seja negociado, o indicador pode receber benefícios. Saiba mais em: Indique um imóvel."
            }
          },
          {
            "@type": "Question",
            "name": "A Apolar trabalha apenas com imóveis residenciais?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Não. A Apolar também atua com imóveis comerciais, industriais, terrenos e empreendimentos imobiliários."
            }
          },
          {
            "@type": "Question",
            "name": "Como posso entrar em contato com a Apolar?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Você pode entrar em contato pelo site https://www.apolar.com.br/fale-conosco/, consultar os telefones das lojas na seção 'Nossas Lojas' ou usar o WhatsApp para atendimento rápido."
            }
          }
        ]
      }

      ]
    }
  },
  metaInfo() {
    return {
      title: this.__("FAQ | Imobiliária em Curitiba - Imóveis à Venda e Locação"),
      meta: [
        {
          vmid: "description",
          name: "description",
          content:"Consulte as dúvidas frequentes ou nos envie também a suas. Acesse agora mesmo e esclareça suas dúvidas!"
        }
      ]
    };
  },
  data() {
    return {
        opened_faq: null,
        faq_list: [
            {
                "title": "Tenho um imóvel para vender ou alugar. O que devo fazer?",
                "description": "Basta clicar em <a targer='_blank' href='https://www.apolar.com.br/anuncie/'>Anuncie</a> ou entrar em contato com uma das nossas lojas. Os corretores Apolar estão preparados para fazer a melhor avaliação do mercado, garantindo agilidade no negócio."
            },
            {
                "title": "Por que devo escolher a Apolar para administrar o meu imóvel?",
                "description": "A Apolar tem mais de 50 anos de tradição no mercado imobiliário e se destaca pela força de divulgação, com mais de 100 lojas interligadas, que trabalham em rede, e equipe de especialistas na oferta do imóvel. Além de parceria com os principais portais imobiliários, onde seu imóvel será anunciado, divulgação nas redes sociais e no próprio portal Apolar, que tem mais de 200 mil acessos/mês. A Apolar também trabalha com uma equipe jurídica própria, com advogados especialistas na área imobiliária, que fornecem toda a assessoria necessária para os clientes."
            },
            {
                "title": "Como funciona o processo de aluguel com a Apolar?",
                "description": "Nosso processo de locação é simples e seguro. Apresentamos as melhores opções de imóveis de acordo com o seu perfil, realizamos a análise cadastral de forma rápida e oferecemos diferentes modalidades de garantia locatícia, como fiador, seguro-fiança e título de capitalização. Tudo isso para tornar a experiência mais ágil e descomplicada."
            },
            {
                "title": "Que tipo de documentação preciso para alugar/comprar ou vender um imóvel?",
                "description": "Para alugar basta apresentar seu RG e CPF para que sua análise cadastral possa ser realizada. Para vender é necessário o documento do imóvel, seu RG e CPF e comprovante do estado civil. Para comprar o imóvel é necessário apresentar RG e CPF, comprovante do estado civil, além de certidões pessoais em caso de financiamento. <br/> <b>*Outros documentos podem ser necessários na dependência de situações especiais. Nesses casos, o corretor/analista fornecerá as orientações pertinentes.</b>"
            },
            {
                "title": "Sou inquilino (a) da Apolar e estou com um problema no imóvel. A quem devo procurar?",
                "description": "A Apolar oferece assistência técnica 24h, de forma gratuita. Basta ligar para o telefone 0800 707 79 56 e agendar uma visita."
            },
            {
                "title": "Como a Apolar garante segurança na compra de um imóvel?",
                "description": "Realizamos uma análise completa da documentação do imóvel e do vendedor para garantir que a transação ocorra sem riscos. Nossos consultores auxiliam em todo o processo, desde a escolha do imóvel até a assinatura do contrato, proporcionando total tranquilidade para o comprador."
            },
            {
                "title": "A Apolar oferece suporte para investidores imobiliários?",
                "description": "Sim! A Apolar possui uma equipe especializada para atender investidores que buscam rentabilidade no mercado imobiliário. Oferecemos análise de mercado, projeções de retorno e assessoria para encontrar os melhores ativos, seja para locação, revenda ou incorporação imobiliária."
            },
            {
                "title": "Como funciona a indicação de imóveis para locação ou venda?",
                "description": "A Apolar conta com programas de indicação de imóveis, nos quais qualquer pessoa pode cadastrar um imóvel disponível para venda ou locação. Caso o imóvel seja negociado, o indicador pode receber benefícios. Para mais informações, acesse: Indique um imóvel."
            },
            {
                "title": "A Apolar trabalha apenas com imóveis residenciais?",
                "description": "Não. A Apolar também atua na intermediação de imóveis comerciais, industriais, terrenos e empreendimentos imobiliários, oferecendo soluções completas para todos os tipos de clientes."
            },
            {
                "title": "Como posso entrar em contato com a Apolar?",
                "description": "Você pode entrar em contato com a Apolar pelos seguintes canais:<ul><li>Site oficial: https://www.apolar.com.br/fale-conosco/</li><li>Telefones das unidades: Disponíveis no site na seção 'Nossas Lojas'</li><li>Atendimento via WhatsApp para negociações rápidas</li></ul>"
            }
        ]
    };
  },
  computed: {


  },
  methods: {
    toogle_faq(faq_idx) {
        this.opened_faq = this.opened_faq == faq_idx ? null : faq_idx
    }
  },
  mounted() {
    if(this.lang == 'es'){
      this.faq_list.pop()
    }
  }
};
</script>

<style scoped lang="scss">
  @import "~@/assets/scss/custom/principal/_faq.scss"
</style>